// Event representing a Location being created as a result of parsing a URL.
class URLParsedEvent {}

export default URLParsedEvent;
